// OptimizedImage — renders <picture> with WebP source for internal /api/files/ URLs,
// falling back to the original. External URLs pass through untouched.
import React from 'react';

const isOptimizable = (src) =>
  typeof src === 'string' &&
  src.includes('/api/files/') &&
  !src.endsWith('.webp') &&
  !src.endsWith('.gif');

const OptimizedImage = React.forwardRef(function OptimizedImage(
  { src, alt = '', className = '', loading = 'lazy', decoding = 'async', ...rest },
  ref
) {
  if (!src) return null;
  if (!isOptimizable(src)) {
    return (
      <img
        ref={ref}
        src={src}
        alt={alt}
        className={className}
        loading={loading}
        decoding={decoding}
        {...rest}
      />
    );
  }

  const webpSrc = `${src}.webp`;
  return (
    <picture>
      <source srcSet={webpSrc} type="image/webp" />
      <img
        ref={ref}
        src={src}
        alt={alt}
        className={className}
        loading={loading}
        decoding={decoding}
        {...rest}
      />
    </picture>
  );
});

export default OptimizedImage;
